"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetTagFocus = void 0;

var isLastTag = function isLastTag(tagCount, i) {
  return i === tagCount - 1;
};

var resetTagFocus = function resetTagFocus(_ref) {
  var refs = _ref.refs,
      deletedIndex = _ref.deletedIndex,
      onLastTagDeleted = _ref.onLastTagDeleted;
  var numberOfTags = refs.length;

  if (isLastTag(numberOfTags, deletedIndex)) {
    // If this was the only tag
    if (numberOfTags === 1) {
      onLastTagDeleted && onLastTagDeleted();
    } // Focus on the penultimate tag
    else if (numberOfTags > 1) {
      var penultimateRef = refs[numberOfTags - 2];

      if (penultimateRef && penultimateRef.current) {
        penultimateRef.current.focus();
      }
    }
  } // If deleting any tag that is not the last one
  else if (deletedIndex < numberOfTags) {
    var nextRef = refs[deletedIndex + 1];

    if (nextRef && nextRef.current) {
      nextRef.current.focus();
    }
  }
};

exports.resetTagFocus = resetTagFocus;